module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isLicensingOfficer ? 'col-md-12 conditions-table' : 'col-md-12'
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Proposed Conditions\n                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.panelBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.panelBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.panelBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.canAddConditions) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addCondition()
      }
    }
  }, [_vm._v("Add Condition")]) : _vm._e()]), _vm._v(" "), _c('datatable', {
    ref: "conditions_datatable",
    attrs: {
      "id": 'conditions-datatable-' + _vm._uid,
      "dtOptions": _vm.condition_options,
      "dtHeaders": _vm.condition_headers
    }
  })], 1)])])]), _vm._v(" "), _c('ConditionDetail', {
    ref: "condition_detail",
    attrs: {
      "application_id": _vm.application.id,
      "conditions": _vm.conditions,
      "licence_activity_tab": _vm.selected_activity_tab_id,
      "condition": _vm.viewedCondition,
      "purposes": _vm.purposes
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02253e2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/application_conditions.vue
// module id = 910
// module chunks = 0